import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {
    CreateShift,
    GetAllCafeterias,
    GetAllCafeteriasByUserId,
    GetCustomAccessByShiftIdFoodie,
    GetShiftById,
    UpdateShift
} from './FoodieShiftApi';

const FoodieShiftSlice = createSlice({
    name: "shift",
    initialState: {
        addEdit: null,
        shiftById: null,
        allCafeterias: null,
        customAccess:null,
    },
    reducers: {
        resetAddEdit: (state, action) => {
            state.addEdit = null;
        },
        resetShiftById: (state, action) => {
            state.shiftById = null;
        }
    },
    extraReducers: (builder) => {
        builder.
        addCase(CreateShift.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }).addCase(UpdateShift.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }).addCase(GetShiftById.fulfilled, (state, {payload}) =>{
            state.shiftById = ResponseApi(payload);
        }).addCase(GetAllCafeterias.fulfilled, (state, {payload}) =>{
            state.allCafeterias = ResponseApi(payload);
        }).addCase(GetAllCafeteriasByUserId.fulfilled, (state, {payload}) =>{
            state.allCafeterias = ResponseApi(payload);
        }).addCase(GetCustomAccessByShiftIdFoodie.fulfilled, (state, {payload}) =>{
            state.customAccess = ResponseApi(payload);
        })
    }

})

export const { resetAddEdit, resetShiftById } = FoodieShiftSlice.actions;

export default FoodieShiftSlice.reducer;
